module.exports = __webpack_public_path__ + "static/media/st.1a259b7a.webp";